<template>
  <div>
    <div v-for="(modal, index) in modals" :key="modal.id">
      <component
        :is="MODALS[modal.id as keyof typeof MODALS]"
        :modelValue="modal.isOpen"
        v-bind="modal.options"
        @update:modelValue="(val: boolean) => handleModalUpdate(Number(index), val)"
        @onClose="onClose(modal.id)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, type Component } from 'vue';
import { useStore } from 'vuex';

// These components have been moved out of the Vuex store; keeping them there caused performance issues.
import NoActiveAgencyModal from '@/components/Agency/NoActiveAgencyModal.vue';
import BulkPromotionModal from '@/components/BulkPromotionModal/BulkPromotionModal.vue';
import ToplistingModal from '@/components/InsertionCard/ListingActionModals/modals/ToplistingModal/ToplistingModal.vue';
import MfaConfirmationModal from '@/components/MfaConfirmationModal/MfaConfirmationModal.vue';
import { ModalIds } from '@/components/ModalManager/types';
import ModalSwitcherAgency from '@/components/ModalSwitcherAgency/ModalSwitcherAgency.vue';
import GotMandateModal from '@/components/SellerLeads/Details/GotMandateModal.vue';
import NotGetMandateModal from '@/components/SellerLeads/Details/NotGetMandateModal.vue';
import ExportCsvModal from '../ExportCsvModal/ExportCsvModal.vue';
import ResetMfaModal from '../ResetMfaModal/ResetMfaModal.vue';

const MODALS: Record<ModalIds, Component> = {
  [ModalIds.AgencySwitcherModal]: ModalSwitcherAgency,
  [ModalIds.NoActiveAgencyModal]: NoActiveAgencyModal,
  [ModalIds.MfaConfirmationModal]: MfaConfirmationModal,
  [ModalIds.GotMandateModal]: GotMandateModal,
  [ModalIds.NotGotMandateModal]: NotGetMandateModal,
  [ModalIds.NotSoldModal]: NotGetMandateModal,
  [ModalIds.PropertySoldModal]: GotMandateModal,
  [ModalIds.ExportCsvModal]: ExportCsvModal,
  [ModalIds.BulkPromotionModal]: BulkPromotionModal,
  [ModalIds.ResetMfaModal]: ResetMfaModal,
  [ModalIds.ToplistingModal]: ToplistingModal,
};

const emit = defineEmits(['onClose']);

const store = useStore();
const modals = computed(() => store.getters.getModals);

const handleModalUpdate = (index: number, val: boolean) => {
  const modalArray = store.getters.getModals;
  modalArray[index].isOpen = val;
  store.commit('setModals', modalArray);
};
const onClose = (modalId: string) => {
  emit('onClose', modalId);
};
</script>
